"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userEmailVerificationApi = void 0;
const createUserEmailVerificationCode = {
    method: "POST",
    url: "/user/email/verification-codes",
    reducer: resp => resp,
    errReducer: resp => resp,
};
const verifyUserEmailVerificationCode = {
    method: "POST",
    url: "/user/email/verify-code",
    reducer: resp => resp,
    errReducer: resp => resp,
};
exports.userEmailVerificationApi = {
    createUserEmailVerificationCode,
    verifyUserEmailVerificationCode,
};
//# sourceMappingURL=userEmailVerification.js.map